// Auto-open FAQ question from URL hash
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const trigger = targetElement.previousElementSibling;

      if (trigger && trigger.classList.contains("collapsible-trigger") && trigger.getAttribute("aria-expanded") !== "true") {
        const isMobile = window.innerWidth < 768;

        if (isMobile) {
          // Mobile: Open first, then scroll to it
          trigger.click();

          setTimeout(function () {
            const headerOffset = 100;
            const elementPosition = trigger.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: "auto",
            });
          }, 400);
        } else {
          // Desktop: Scroll first, then open (UNCHANGED - virker perfekt)
          const headerOffset = 150;
          const elementPosition = trigger.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "auto",
          });

          setTimeout(function () {
            trigger.click();
          }, 100);
        }
      }
    }
  }
});
